import { render, staticRenderFns } from "./HotLink.vue?vue&type=template&id=33305596&scoped=true"
import script from "./HotLink.vue?vue&type=script&lang=js"
export * from "./HotLink.vue?vue&type=script&lang=js"
import style0 from "./HotLink.scss?vue&type=style&index=0&id=33305596&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33305596",
  null
  
)

export default component.exports